<template>
  <div>
    <v-container fluid>
      <template v-if="isCustomerSupportService && selectedBot.unlock_survey">
        <SurveySetting />
      </template>
    </v-container>
  </div>
</template>

<script>
import SurveySetting from '@/components/view/ticket3/ticket-management/Setting/CustomerSupportService/SurveySetting.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'SettingView',
  components: {
    SurveySetting
  },
  computed: {
    ...mapGetters(['selectedBot', 'isCustomerSupportService'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ticket/Setting/index.vue